import {Project} from "../api/Project";

export const foodhubProject: Project = {
    id: 1,
    title: 'The FoodHub Website',
    description: 'The project showing the online system for a restaurant including online shopping and online reservation module.',
    link: 'http://the-food-hub.herokuapp.com/',
    image: 'resources/icons/foodhub.png',
    startDate: 'March 2017',
    completeDate: 'April 2017',
    technologies: {
        frontend: [
            "ReactJS",
            "Node.js",
            "FontAwesome",
            "BootStrap",
        ],
        backend: [
            "Java",
            "Spring Boot",
            "Hibernate",
            "JPA",
            "Maven",
        ]
    },
    hidden: false
};